import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { style: {"width":"100%"} }
const _hoisted_6 = { class: "t6_table_b" }
const _hoisted_7 = { class: "td_center" }
const _hoisted_8 = { class: "td_center" }
const _hoisted_9 = { class: "td_center" }
const _hoisted_10 = { class: "td_center" }
const _hoisted_11 = {
  key: 0,
  class: "pagination"
}
const _hoisted_12 = { class: "t6_table_b t6_table_b2" }
const _hoisted_13 = { colspan: "3" }
const _hoisted_14 = { colspan: "3" }
const _hoisted_15 = { colspan: "3" }
const _hoisted_16 = { colspan: "3" }

import { preComplainList } from '@/config/request';
import { reactive } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

const store = useStore()

const data = reactive({
  tabDataList: [] as any,
})
const dialog = reactive({
  dialogVisible: false,
  title: '咨询详情',
  detail: {} as any,
})
const showDetail = (item:any) => {
  dialog.detail = item
  dialog.dialogVisible = true
}
const paginate = reactive({
  pageNo: 1,
  pageSize: 10,
  pageSizes: [5,10,20],
  total: 0,
})
const handleCurrentChange = (index:any) => {
  paginate.pageNo = index
  init()
}
const handleSizeChange = (index:any) => {
  paginate.pageSize = index
  init()
}
/**
 * 格式化日期为yyyy-MM-dd格式
 * @param dateString 日期字符串
 * @returns 格式化后的日期字符串
 */
const formatDate = (dateString: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  // 检查日期是否有效
  if (isNaN(date.getTime())) return dateString;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
const init = async() => {
  const type = '1'    //  1表示咨询
  let param = {
    pageNo: paginate.pageNo,
    pageSize: paginate.pageSize,
    sfhf: '1',
    type: type
  }
  const res = await preComplainList(param) as any
  let reaultData = res.result.result
  data.tabDataList = reaultData.records || []
  paginate.total = reaultData.total || 0

}
init()


return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[11] || (_cache[11] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "container mar_b" }, [
            _createElementVNode("div", { class: "t6_breadCream" }, [
              _createElementVNode("span", null, "首页"),
              _createElementVNode("i", null, ">"),
              _createTextVNode(),
              _createElementVNode("span", null, " 咨询回复")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        width: "5%",
                        class: "td_center"
                      }, "序号"),
                      _createElementVNode("th", {
                        width: "60%",
                        class: "td_center"
                      }, "咨询标题"),
                      _createElementVNode("th", { class: "td_center" }, "咨询时间"),
                      _createElementVNode("th", {
                        width: "10%",
                        class: "td_center"
                      }, "操作")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.tabDataList, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", { key: i }, [
                        _createElementVNode("td", _hoisted_7, _toDisplayString(i+1), 1),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(item.maintitle), 1),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(formatDate(item.createTime)), 1),
                        _createElementVNode("td", _hoisted_10, [
                          _createVNode(_component_el_button, {
                            size: "small",
                            type: "success",
                            onClick: ($event: any) => (showDetail(item))
                          }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createTextVNode("详情", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                (data.tabDataList.length === 0)
                  ? (_openBlock(), _createBlock(_component_el_empty, {
                      key: 0,
                      description: "暂无数据"
                    }))
                  : _createCommentVNode("", true)
              ]),
              (paginate.total > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_el_pagination, {
                      background: "",
                      onCurrentChange: handleCurrentChange,
                      onSizeChange: handleSizeChange,
                      layout: "sizes, prev, pager, next, ->, total",
                      "page-size": paginate.pageSize,
                      "page-sizes": paginate.pageSizes,
                      total: paginate.total
                    }, null, 8, ["page-size", "page-sizes", "total"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_el_dialog, {
                modelValue: dialog.dialogVisible,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog.dialogVisible) = $event)),
                title: dialog.title,
                width: "60%",
                class: "dialog_content"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("table", _hoisted_12, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[3] || (_cache[3] = _createElementVNode("th", null, "咨询标题", -1)),
                          _createElementVNode("td", _hoisted_13, _toDisplayString(dialog.detail.maintitle), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[4] || (_cache[4] = _createElementVNode("th", null, "咨询时间", -1)),
                          _createElementVNode("td", null, _toDisplayString(formatDate(dialog.detail.createTime)), 1),
                          _cache[5] || (_cache[5] = _createElementVNode("th", null, "咨询部门", -1)),
                          _createElementVNode("td", null, _toDisplayString(dialog.detail.departmentName), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[6] || (_cache[6] = _createElementVNode("th", null, "咨询内容", -1)),
                          _createElementVNode("td", _hoisted_14, _toDisplayString(dialog.detail.content), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[7] || (_cache[7] = _createElementVNode("th", null, "回复时间", -1)),
                          _createElementVNode("td", _hoisted_15, _toDisplayString(formatDate(dialog.detail.modifytime)), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[8] || (_cache[8] = _createElementVNode("th", null, "回复内容", -1)),
                          _createElementVNode("td", _hoisted_16, _toDisplayString(dialog.detail.hfnr), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "title"])
            ])
          ])
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("div", null, null, -1))
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})